import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const FuelIntakeConfig = {
    auth: [...authRoles.admin, ...authRoles.hauling],
    routes: [{ path: '/list-fuel-intake', component: FuseLoadable({ loader: () => import('./FuelIntakeApp') }) }],
};

export default FuelIntakeConfig;
